import { TimeCardList } from '../../../../../js/api';
import { formatApiDate } from '../../../utils/date';

type Props = {
  timecards: TimeCardList[];
};

export function TimecardReview({ timecards }: Props) {
  if (timecards.length === 0) {
    return null;
  }

  if (timecards.length > 1) {
    const handleClick = () => {
      window.location.href = '/app/provider/timecards';
    };
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
        className="tw:bg-stoplight-danger/10 tw:rounded-xl tw:p-4 tw:border tw:border-stoplight-danger/20  tw:hover:bg-stoplight-danger/20 tw:transition-colors tw:cursor-pointer"
      >
        <div className="tw:flex tw:items-start tw:gap-3">
          <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-stoplight-danger tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <i className="fa-solid fa-fw fa-calendar-check tw:text-white tw:text-base tw:sm:text-lg" />
          </div>
          <div className="tw:flex-col">
            <div className="tw:font-medium tw:text-stoplight-danger tw:hover:underline">
              {timecards.length} Timecard{timecards.length > 1 ? 's' : ''} Need
              {timecards.length > 1 ? '' : 's'} Verification
            </div>
            <div className="tw:text-sm">Click to view and respond</div>
          </div>
        </div>
      </div>
    );
  }

  const timecard = timecards[0];
  const facilityName = timecard.facility?.name;

  const handleClick = () => {
    window.location.href = `/app/provider/timecard/${timecard.id}`;
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      className="tw:bg-warning-section-bg tw:rounded-xl tw:p-4 tw:border tw:border-orange-300/20 tw:hover:bg-orange-300/20 tw:transition-colors tw:cursor-pointer"
    >
      <div className="tw:flex tw:items-start tw:gap-3">
        <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-warning-section-text tw:rounded-full tw:flex tw:items-center tw:justify-center">
          <i className="fa-solid fa-fw fa-calendar-lines-pen tw:text-white tw:text-base tw:sm:text-lg" />
        </div>
        <div className="tw:flex-col">
          <div className="tw:font-medium tw:text-warning-section-text tw:hover:underline">
            Click to View Updated Assignment
          </div>
          <div className="tw:text-sm tw:text-zinc-700">
            {facilityName} assignment from {formatApiDate(timecard.start_on)} to{' '}
            {formatApiDate(timecard.end_on)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TimecardReview;
